import { Market } from '../../data/types';

export const getAssetsFromMarket = (market: Market) => Array.from(new Set([
  ...market.borrowableAssets || [],
  ...market.collateralableAssets || [],
]));
